export const SKILL_ALIASES = Object.freeze({
  // v2 -> canônico v18
  cog_funcoes_executivas: 'cog_funcoes_exec',
  aca_comunicacao: 'soc_comunicacao',
  psi_motora_fina: 'psi_coordenacao_fina',
  psi_motora_global: 'psi_coordenacao_ampla',
  psi_lateralidade: 'psi_esquema_corporal',
  soc_turnos: 'soc_interacao',

  // variações textuais e simulação -> canônico v18
  sim_atencao: 'cog_atencao',
  atencao: 'cog_atencao',
  atenção: 'cog_atencao',
  sim_memoria: 'cog_memoria',
  memoria: 'cog_memoria',
  memória: 'cog_memoria',
  sim_raciocinio: 'cog_raciocinio',
  raciocinio: 'cog_raciocinio',
  raciocínio: 'cog_raciocinio',
  sim_compreensao: 'cog_raciocinio',
  compreensao: 'cog_raciocinio',
  compreensão: 'cog_raciocinio',
  funcoes_executivas: 'cog_funcoes_exec',
  funções_executivas: 'cog_funcoes_exec',

  consciencia_fonologica: 'aca_consciencia_fonologica',
  consciência_fonológica: 'aca_consciencia_fonologica',
  sim_leitura: 'aca_leitura',
  leitura: 'aca_leitura',
  sim_escrita: 'aca_escrita',
  escrita: 'aca_escrita',
  sim_matematica: 'aca_matematica',
  matematica: 'aca_matematica',
  matemática: 'aca_matematica',

  sim_motora_fina: 'psi_coordenacao_fina',
  motora_fina: 'psi_coordenacao_fina',
  coordenacao_fina: 'psi_coordenacao_fina',
  coordenação_fina: 'psi_coordenacao_fina',
  sim_motora_global: 'psi_coordenacao_ampla',
  motora_global: 'psi_coordenacao_ampla',
  coordenacao_ampla: 'psi_coordenacao_ampla',
  coordenação_ampla: 'psi_coordenacao_ampla',
  sim_oculomanual: 'psi_oculomanual',
  oculomanual: 'psi_oculomanual',
  óculo_manual: 'psi_oculomanual',
  equilibrio: 'psi_equilibrio',
  equilíbrio: 'psi_equilibrio',
  sim_esquema: 'psi_esquema_corporal',
  esquema: 'psi_esquema_corporal',
  esquema_corporal: 'psi_esquema_corporal',
  sim_lateralidade: 'psi_esquema_corporal',
  lateralidade: 'psi_esquema_corporal',

  sim_interacao: 'soc_interacao',
  interacao: 'soc_interacao',
  interação: 'soc_interacao',
  turnos: 'soc_interacao',
  sim_oralidade: 'soc_comunicacao',
  oralidade: 'soc_comunicacao',
  comunicacao: 'soc_comunicacao',
  comunicação: 'soc_comunicacao',
  sim_regras: 'soc_autorregulacao',
  regras: 'soc_autorregulacao',
  sim_frustracao: 'soc_autorregulacao',
  frustracao: 'soc_autorregulacao',
  frustração: 'soc_autorregulacao',
  sim_autonomia: 'soc_autonomia',
  autonomia: 'soc_autonomia',
});

export function normalizarHabilidadeId(id) {
  const value = String(id || '').trim().toLowerCase();
  return SKILL_ALIASES[value] || value;
}

export function normalizarHabilidadesLista(valor) {
  if (!valor) return [];
  const lista = Array.isArray(valor) ? valor : [valor];
  return [...new Set(lista.filter(Boolean).map(normalizarHabilidadeId))];
}
